import request from '@/utils/request'

export function list(query) {
    return request({
        url: '/stores/list',
        method: 'get',
        params: query
    })
}

export function info(id) {
    return request({
        url: '/stores/info/' + id,
        method: 'get'
    })
}

export function save(data) {
    return request({
        url: '/stores/save',
        method: 'post',
        data
    })
}

export function update(data) {
    return request({
        url: '/stores/update',
        method: 'post',
        data
    })
}

export function remove(data) {
    return request({
        url: '/stores/delete',
        method: 'post',
        data
    })
}

